import { render, staticRenderFns } from "./TemplateFiles.vue?vue&type=template&id=a3bf8fa0&scoped=true"
import script from "./TemplateFiles.vue?vue&type=script&lang=js"
export * from "./TemplateFiles.vue?vue&type=script&lang=js"
import style0 from "./TemplateFiles.vue?vue&type=style&index=0&id=a3bf8fa0&prod&scoped=true&lang=css"
import style1 from "./TemplateFiles.vue?vue&type=style&index=1&id=a3bf8fa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bf8fa0",
  null
  
)

export default component.exports